export const NEW_DOCUMENT_ID = "new";

export const DOCUMENT_SOURCES = {
  local: "Local",
  sharepoint: "Sharepoint",
};
